import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

// Components
import AppointmentInfo from './AppointmentInfo';

// Selectors
import { dealerLogoURL as computeDealerLogo } from 'store/reducers/localizationString/selectors';
import {
  showHeader,
  getDealerName
} from 'store/reducers/dealerSettings/selectors';
import { getDealerLogo } from 'store/reducers/dealerData/selectors';
import { getCTABanner } from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = state => ({
  dealerLogoURL: computeDealerLogo(state) || getDealerLogo(state),
  showHeader: showHeader(state),
  dealerName: getDealerName(state),
  ctaBanner: getCTABanner(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    {}
  )
)(AppointmentInfo);



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentInfo/AppointmentInfoContainer.js